/* Seoulogy Academy sections — interactions (DOM-driven; content comes from the theme editor) */
(function () {
  'use strict';
  if (window.__akInit) return; window.__akInit = true;
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function smoothTo(sel) {
    const el = document.querySelector(sel);
    if (el) el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Hanok hero ---------- */
  $$('.ak-hero').forEach((hero) => {
    const stage = $('.hanok-stage', hero);
    let opened = false;

    /* Content gate: everything below the hero stays hidden until the doors open.
       Skipped inside the theme editor, and fails open if JS or :has() is unavailable. */
    const inEditor = window.Shopify && window.Shopify.designMode;
    let entered = false;
    try { entered = sessionStorage.getItem('ak-entered') === '1'; } catch (e) { /* private mode */ }
    if (!inEditor && !entered) document.documentElement.classList.add('ak-gate');
    function reveal() {
      if (!document.documentElement.classList.contains('ak-gate')) return;
      document.documentElement.classList.remove('ak-gate');
      document.documentElement.classList.add('ak-reveal');
      try { sessionStorage.setItem('ak-entered', '1'); } catch (e) { /* private mode */ }
    }

    function enter(dest) {
      if (opened || reducedMotion) {
        stage.classList.add('is-open');
        opened = true;
        reveal();
        smoothTo(dest);
        return;
      }
      opened = true;
      stage.classList.add('is-open');
      setTimeout(reveal, 650);
      setTimeout(() => smoothTo(dest), 1250);
    }
    hero.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ak-enter]');
      if (btn) { e.preventDefault(); enter(btn.getAttribute('data-ak-enter') || '#ak-route-finder'); return; }
      const scrollHint = e.target.closest('.hero__scroll');
      if (scrollHint && document.documentElement.classList.contains('ak-gate')) {
        enter(scrollHint.getAttribute('data-ak-scroll') || '#ak-route-finder');
      }
    });
    requestAnimationFrame(() => hero.classList.add('is-ready'));

    /* Interactive lanterns: drag to swing (with momentum), quick click / tap /
       right-click to switch the light on and off. */
    $$('.hanok-lantern', stage).forEach((lantern) => {
      const lamp = $('i', lantern);
      if (!lamp) return;
      let held = false, moved = false, startT = 0, startX = 0, startY = 0;
      let angle = 0, vel = 0, lastA = 0, lastT = 0, raf = null;
      const pivot = () => {
        const r = lantern.getBoundingClientRect();
        return { x: r.left + r.width / 2, y: r.top };
      };
      lantern.addEventListener('contextmenu', (e) => e.preventDefault());
      lantern.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        held = true; moved = false;
        startT = Date.now(); startX = e.clientX; startY = e.clientY;
        try { lantern.setPointerCapture(e.pointerId); } catch (err) { /* ok */ }
        lantern.classList.add('is-held');
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        vel = 0; lastA = angle; lastT = performance.now();
      });
      lantern.addEventListener('pointermove', (e) => {
        if (!held || reducedMotion) return;
        if (Math.abs(e.clientX - startX) + Math.abs(e.clientY - startY) > 6) moved = true;
        const p = pivot();
        const a = Math.atan2(e.clientX - p.x, Math.max(24, e.clientY - p.y)) * 180 / Math.PI;
        angle = Math.max(-65, Math.min(65, a));
        const now = performance.now();
        if (now - lastT > 16) {
          vel = (angle - lastA) / (now - lastT) * 16;
          lastA = angle; lastT = now;
        }
        lamp.style.transform = 'rotate(' + angle + 'deg)';
      });
      const settle = () => {
        lamp.style.transform = '';
        lantern.classList.remove('is-held');
        angle = 0; vel = 0; raf = null;
      };
      const release = () => {
        if (!held) return;
        held = false;
        if (!moved && Date.now() - startT < 350) {
          lantern.classList.toggle('is-off');
          settle();
          return;
        }
        if (reducedMotion) { settle(); return; }
        const step = () => {
          vel += -0.055 * angle - 0.012 * vel;
          angle += vel;
          lamp.style.transform = 'rotate(' + angle + 'deg)';
          if (Math.abs(angle) < 0.4 && Math.abs(vel) < 0.08) { settle(); return; }
          raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      };
      lantern.addEventListener('pointerup', release);
      lantern.addEventListener('pointercancel', release);
    });
    if (!reducedMotion && window.matchMedia('(hover: hover) and (min-width: 900px)').matches) {
      const layers = $$('[data-depth]', stage);
      let raf = null;
      document.addEventListener('pointermove', (e) => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          const x = (e.clientX / window.innerWidth - 0.5);
          const y = (e.clientY / window.innerHeight - 0.5);
          layers.forEach((l) => {
            const d = parseFloat(l.getAttribute('data-depth')) / 2;
            const base = l.classList.contains('hanok-gate') ? 'translateX(-50%) ' : '';
            l.style.transform = base + 'translate(' + (-x * d) + 'px,' + (-y * d * 0.6) + 'px)';
          });
          raf = null;
        });
      }, { passive: true });
    }
  });

  /* ---------- Generic: scroll buttons ---------- */
  document.addEventListener('click', (e) => {
    const sc = e.target.closest('[data-ak-scroll]');
    if (sc) { e.preventDefault(); smoothTo(sc.getAttribute('data-ak-scroll')); }
  });

  /* ---------- Route finder ---------- */
  $$('[data-ak-rf]').forEach((rf) => {
    const wa = rf.getAttribute('data-whatsapp') || 'https://wa.me/447429813779';
    const coursesAnchor = rf.getAttribute('data-courses-anchor') || '#ak-courses';
    const sevenAnchor = rf.getAttribute('data-seven-anchor') || '#ak-seven-day';
    const contactAnchor = rf.getAttribute('data-contact-anchor') || '#ak-contact';
    const datesAnchor = rf.getAttribute('data-dates-anchor') || '#ak-dates';
    const steps = [
      { id: 'name', type: 'text', label: 'What is your name?', placeholder: 'Your first name' },
      { id: 'location', type: 'text', label: 'Where are you based?', placeholder: 'e.g. London' },
      { id: 'quals', type: 'text', label: 'What qualifications do you currently hold?', placeholder: 'e.g. Level 3 Beauty Therapy…' },
      { id: 'level3', type: 'yesno', label: 'Do you hold Level 3 Beauty Therapy or equivalent?' },
      { id: 'peel', type: 'yesno', label: 'Have you completed chemical peel training?' },
      { id: 'needling', type: 'yesno', label: 'Have you completed microneedling training?' },
      { id: 'level4', type: 'yesno', label: 'Are you Level 4 qualified?' },
      { id: 'medical', type: 'yesno', label: 'Are you a nurse or medical professional?' },
      { id: 'goal', type: 'choice', label: 'What is your main goal?', options: [
        { value: 'start', label: 'I want to start specialising in Korean skin treatments' },
        { value: 'advanced', label: 'I want to progress into advanced Korean protocols' },
        { value: 'peel', label: 'I want chemical peel training' },
        { value: 'needling', label: 'I want microneedling training' },
        { value: 'sevenday', label: 'I want the 7 Day Intensive with Korean educators' },
        { value: 'unsure', label: 'I am not sure and need guidance' }
      ] }
    ];
    const stepsWrap = $('[data-rf-steps]', rf);
    const form = $('form', rf);
    const result = $('[data-rf-result]', rf);
    const nextBtn = $('[data-rf-next]', rf);
    const backBtn = $('[data-rf-back]', rf);
    const progress = $('[data-rf-progress]', rf);
    const answers = {};
    let idx = 0;

    stepsWrap.innerHTML = steps.map((q, i) => {
      let inner = '<label class="rf-step__label" for="rf-' + q.id + '">' + esc(q.label) + '</label>';
      if (q.type === 'text') inner += '<input type="text" id="rf-' + q.id + '" placeholder="' + esc(q.placeholder || '') + '">';
      else if (q.type === 'yesno') inner += '<div class="rf-options rf-yesno"><button type="button" class="rf-option" data-value="yes"><span class="dot"></span>Yes</button><button type="button" class="rf-option" data-value="no"><span class="dot"></span>No</button></div>';
      else inner += '<div class="rf-options">' + q.options.map((o) => '<button type="button" class="rf-option" data-value="' + o.value + '"><span class="dot"></span>' + esc(o.label) + '</button>').join('') + '</div>';
      inner += '<p class="rf-error">Please choose an answer to continue.</p>';
      return '<div class="rf-step' + (i === 0 ? ' is-active' : '') + '" data-step="' + i + '">' + inner + '</div>';
    }).join('');

    stepsWrap.addEventListener('click', (e) => {
      const opt = e.target.closest('.rf-option');
      if (!opt) return;
      const step = opt.closest('.rf-step');
      $$('.rf-option', step).forEach((o) => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');
      answers[steps[+step.dataset.step].id] = opt.getAttribute('data-value');
      $('.rf-error', step).classList.remove('show');
    });

    function show(i) {
      idx = i;
      $$('.rf-step', stepsWrap).forEach((s, j) => s.classList.toggle('is-active', j === i));
      backBtn.hidden = i === 0;
      nextBtn.textContent = i === steps.length - 1 ? 'Show my route' : 'Next';
      progress.style.width = ((i + 1) / (steps.length + 1) * 100) + '%';
    }
    show(0);

    nextBtn.addEventListener('click', () => {
      const q = steps[idx];
      const stepEl = $$('.rf-step', stepsWrap)[idx];
      if (q.type === 'text') answers[q.id] = $('input', stepEl).value.trim();
      else if (!answers[q.id]) { $('.rf-error', stepEl).classList.add('show'); return; }
      if (idx < steps.length - 1) show(idx + 1); else finish();
    });
    backBtn.addEventListener('click', () => { if (idx > 0) show(idx - 1); });
    form.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); nextBtn.click(); } });

    function recommend(a) {
      const yes = (k) => a[k] === 'yes';
      const p2 = yes('level4') || yes('medical') || (yes('level3') && yes('peel') && yes('needling'));
      const R = {};
      switch (a.goal) {
        case 'sevenday':
          R.course = '7 Day Intensive Korean Skin Training Programme'; R.target = sevenAnchor;
          R.why = ['An immersive academy-style experience with Korean educators in London',
            yes('medical') ? 'Ideal for your medical background' : 'Designed for advanced practitioners — the team will confirm your fit'];
          break;
        case 'peel':
          if (!yes('level3')) { R.guidance = true; break; }
          R.course = 'Chemical Peel CPD'; R.target = coursesAnchor;
          R.why = ['Focused CPD route with portal theory and one practical day', 'Professional kit worth £150 GBP included', 'A stepping stone toward Korean Skin Specialist Part II'];
          break;
        case 'needling':
          if (!yes('level3')) { R.guidance = true; break; }
          R.course = 'Microneedling CPD'; R.target = coursesAnchor;
          R.why = ['Focused CPD route with portal theory and one practical day', 'Professional kit worth £150 GBP included', 'A stepping stone toward Korean Skin Specialist Part II'];
          break;
        case 'advanced':
          if (p2) {
            R.course = 'Korean Skin Specialist — Part II'; R.target = coursesAnchor;
            R.why = ['Your background meets the Part II entry criteria', 'Advanced needling logic, peel layering and corrective programmes', 'Includes Green Sea Peel CPD certification'];
          } else if (yes('level3')) {
            R.course = 'Korean Skin Specialist — Part I'; R.target = coursesAnchor;
            R.why = ['Part I builds the foundation that unlocks Part II', 'Adding Chemical Peel CPD and Microneedling CPD also opens the Part II route', 'You can progress into advanced Korean protocols step by step'];
          } else R.guidance = true;
          break;
        case 'start':
          if (yes('level3')) {
            R.course = 'Korean Skin Specialist — Part I'; R.target = coursesAnchor;
            R.why = ['The signature starting point for Korean skin specialisation', 'Consultation, analysis, treatment planning and glass-skin journeys', 'Level 3 or equivalent — you meet the entry requirement'];
          } else R.guidance = true;
          break;
        default: R.guidance = true;
      }
      if (R.guidance) {
        R.course = 'Personal guidance from the Seoulogy team'; R.target = contactAnchor;
        R.why = yes('level3')
          ? ['You have options — the team will match your background to the right route', 'Korean Skin Specialist Part I is the most common starting point']
          : ['Level 3 Beauty Therapy or equivalent is the entry point for our routes', 'The team can guide you toward foundation education first'];
      }
      return R;
    }

    function finish() {
      const R = recommend(answers);
      const name = answers.name ? esc(answers.name.split(' ')[0]) : '';
      progress.style.width = '100%';
      form.hidden = true;
      result.hidden = false;
      const msg = "Hi Seoulogy Academy, I'm " + (answers.name || 'interested in training') +
        (answers.location ? ' from ' + answers.location : '') +
        '. The route finder recommended: ' + R.course + ". I'd like to know more.";
      result.innerHTML =
        '<span class="rf-result__badge">Your recommended route</span>' +
        '<h3>' + (name ? name + ', ' : '') + 'your path is<br>' + esc(R.course) + '</h3>' +
        '<ul class="rf-result__why">' + R.why.map((w) => '<li>' + esc(w) + '</li>').join('') + '</ul>' +
        '<div class="rf-result__actions">' +
        '<a class="ak-btn ak-btn--burgundy" href="' + wa + '?text=' + encodeURIComponent(msg) + '" target="_blank" rel="noopener">Book or ask us</a>' +
        '<button type="button" class="ak-btn ak-btn--ghost" data-ak-scroll="' + R.target + '">View details</button>' +
        '<button type="button" class="ak-btn ak-btn--ghost" data-ak-scroll="' + datesAnchor + '">View London dates</button>' +
        '</div>' +
        '<button class="rf-result__restart" type="button" data-rf-restart>Start again</button>';
      $('[data-rf-restart]', result).addEventListener('click', () => {
        Object.keys(answers).forEach((k) => delete answers[k]);
        $$('.rf-option', stepsWrap).forEach((o) => o.classList.remove('is-selected'));
        $$('.rf-step input', stepsWrap).forEach((i2) => { i2.value = ''; });
        result.hidden = true; form.hidden = false; show(0);
      });
    }
  });

  /* ---------- Why-train tabs ---------- */
  $$('[data-ak-tabs]').forEach((wrap) => {
    wrap.addEventListener('click', (e) => {
      const tab = e.target.closest('.wt-tab');
      if (!tab) return;
      const tabs = $$('.wt-tab', wrap);
      const panels = $$('.wt-panel', wrap.closest('.why-train__content') || wrap.parentElement);
      const i = tabs.indexOf(tab);
      tabs.forEach((t, j) => { t.classList.toggle('is-active', j === i); t.setAttribute('aria-selected', String(j === i)); });
      panels.forEach((p, j) => { p.classList.toggle('is-active', j === i); p.hidden = j !== i; });
    });
  });

  /* ---------- Video: keep running ---------- */
  $$('[data-ak-video], video.ak-video').forEach((video) => {
    if (reducedMotion) { video.setAttribute('controls', ''); return; }
    video.muted = true; video.loop = true; video.autoplay = true; video.setAttribute('playsinline', '');
    const tryPlay = () => video.play().catch(() => {});
    video.addEventListener('canplay', tryPlay, { once: true });
    video.addEventListener('pause', tryPlay);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tryPlay(); });
    tryPlay();
  });

  /* ---------- Details / journey expanders ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ak-details]');
    if (btn) {
      const panel = document.getElementById(btn.getAttribute('data-ak-details'));
      if (!panel) return;
      const open = panel.style.maxHeight && panel.style.maxHeight !== '0px';
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
      btn.textContent = open ? (btn.getAttribute('data-label-open') || 'Know more about this course') : (btn.getAttribute('data-label-close') || 'Hide course details');
      return;
    }
    const t = e.target.closest('.journey__toggle');
    if (t) {
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      const open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', String(!open));
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    }
  });

  /* ---------- Lightbox (created on demand) ---------- */
  function getLightbox() {
    let lb = $('#AkLightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'lightbox sgy-ak';
    lb.id = 'AkLightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML = '<button class="lightbox__close" data-lightbox-close aria-label="Close image">&times;</button><figure><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(lb);
    return lb;
  }
  document.addEventListener('click', (e) => {
    const fig = e.target.closest('[data-full]');
    if (fig) {
      const lb = getLightbox();
      $('img', lb).src = fig.getAttribute('data-full');
      $('img', lb).alt = fig.getAttribute('data-caption') || '';
      $('figcaption', lb).textContent = fig.getAttribute('data-caption') || '';
      lb.classList.add('open');
      document.body.classList.add('no-scroll');
      return;
    }
    const lb = $('#AkLightbox');
    if (lb && (e.target.closest('[data-lightbox-close]') || e.target === lb)) {
      lb.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const lb = $('#AkLightbox');
    if (lb) { lb.classList.remove('open'); document.body.classList.remove('no-scroll'); }
  });

  /* ---------- FAQ accordion (academy-scoped) ---------- */
  document.addEventListener('click', (e) => {
    const q = e.target.closest('.sgy-ak .faq__q');
    if (!q) return;
    const panel = document.getElementById(q.getAttribute('aria-controls'));
    if (!panel) return;
    const open = q.getAttribute('aria-expanded') === 'true';
    q.setAttribute('aria-expanded', String(!open));
    panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
  });

  /* ---------- Calendar iframe ---------- */
  $$('[data-ak-calendar]').forEach((frame) => {
    const id = frame.getAttribute('data-cal-id');
    const tz = frame.getAttribute('data-cal-tz') || 'Europe/London';
    if (!id) return;
    const mobile = window.matchMedia('(max-width: 700px)').matches;
    frame.src = 'https://calendar.google.com/calendar/embed?src=' + encodeURIComponent(id) +
      '&ctz=' + encodeURIComponent(tz) + '&mode=' + (mobile ? 'AGENDA' : 'MONTH') +
      '&showTitle=0&showPrint=0&showTabs=1&showCalendars=0&showTz=0&wkst=2&bgcolor=%23FFFFFF';
  });

  /* ---------- Scroll reveal with fallback ---------- */
  const rvs = $$('.sgy-ak .rv');
  if (!reducedMotion && 'IntersectionObserver' in window && rvs.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    rvs.forEach((el) => io.observe(el));
    let raf = null;
    const revealNow = () => {
      raf = null;
      rvs.forEach((el) => {
        if (el.classList.contains('in')) return;
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
      });
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(revealNow); };
    window.addEventListener('scroll', queue, { passive: true });
    setTimeout(revealNow, 600);
    setTimeout(revealNow, 1600);
  } else {
    rvs.forEach((el) => el.classList.add('in'));
  }
})();
